import { LoadingSpinner } from "@clockwise/web-commons/src/ui/LoadingSpinner";
import React, { useEffect } from "react";
import { usePlannerToAIRedirect } from "../components/web-app-calendar/hooks/usePlannerToAIRedirect";
import { page, PageEvents } from "../util/analytics.util";

const PlannerPage = () => {
  useEffect(() => {
    page(PageEvents.PLANNER);
  }, []);

  usePlannerToAIRedirect();

  return <LoadingSpinner />;
};

export default PlannerPage;
